"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { areaSlugs, coreAreaServices, manualAreaContent } from "@/app/data/manualAreaContent";

const links = [
  { href: "/about", label: "About" },
  { href: "/gallery", label: "Gallery" },
  { href: "/contactUs", label: "Contact" },
];

export default function DesktopMenu() {
  const pathname = usePathname();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isServiceRoute = pathname.startsWith("/services") || pathname.startsWith("/bangalore");

  return (
    <ul className="relative hidden items-center gap-7 text-sm font-bold text-white/80 md:flex">
      <li className="group relative">
        <Link href="/" className={`relative py-1 transition duration-300 ${pathname === "/" ? "text-white" : "hover:text-white"}`}>
          Home
          <span className={`absolute -bottom-1 left-0 h-[2px] bg-[#7dd3fc] transition-all duration-300 ${pathname === "/" ? "w-full" : "w-0 group-hover:w-full"}`} />
        </Link>
      </li>

      <li className="group relative" onMouseEnter={() => setIsDropdownOpen(true)} onMouseLeave={() => setIsDropdownOpen(false)}>
        <button className={`group relative py-1 transition duration-300 ${isServiceRoute ? "text-white" : "text-white/80 hover:text-white"}`} aria-expanded={isDropdownOpen}>
          Services
          <span className={`absolute -bottom-1 left-0 h-[2px] bg-[#7dd3fc] transition-all duration-300 ${isDropdownOpen || isServiceRoute ? "w-full" : "w-0 group-hover:w-full"}`} />
        </button>

        {isDropdownOpen && (
          <div className="absolute left-1/2 top-full z-50 mt-2 grid w-[760px] -translate-x-[32%] grid-cols-[.9fr_1.1fr] gap-2 rounded-[1.25rem] border border-[#0f172a]/10 bg-white/98 p-3 shadow-2xl backdrop-blur-xl">
            <div className="scrollbar-hide max-h-[500px] overflow-y-auto rounded-2xl bg-[#f0f9ff] p-2">
              <p className="px-3 pb-2 pt-1 text-[10px] font-extrabold tracking-[0.15em] text-[#075985] uppercase">Core services</p>
              {coreAreaServices.map((service) => (
                <Link key={service.slug} href={`/services/${service.slug}`} className="block rounded-xl px-3 py-2.5 text-sm font-semibold text-[#475569] transition hover:bg-[#e0f2fe] hover:text-[#0c4a6e]">
                  {service.title}
                </Link>
              ))}
            </div>
            <div className="scrollbar-hide max-h-[500px] overflow-y-auto p-2">
              <p className="px-3 pb-2 pt-1 text-[10px] font-extrabold tracking-[0.15em] text-[#075985] uppercase">Bengaluru neighbourhoods</p>
              <div className="grid grid-cols-2 gap-1">
                {areaSlugs.map((area) => (
                  <Link key={area} href={`/bangalore/${area}`} className="rounded-lg px-3 py-2 text-xs font-semibold text-[#475569] transition hover:bg-[#e0f2fe] hover:text-[#0c4a6e]">
                    {manualAreaContent[area].name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}
      </li>

      {links.map((link) => (
        <li key={link.href} className="group relative">
          <Link href={link.href} className={`relative py-1 transition duration-300 ${pathname === link.href ? "text-white" : "hover:text-white"}`}>
            {link.label}
            <span className={`absolute -bottom-1 left-0 h-[2px] bg-[#7dd3fc] transition-all duration-300 ${pathname === link.href ? "w-full" : "w-0 group-hover:w-full"}`} />
          </Link>
        </li>
      ))}

      <li>
        <a href="tel:7995792953" className="ml-2 rounded-full bg-[#0369a1] px-5 py-2.5 text-sm font-extrabold text-white shadow-[0_8px_20px_rgba(3,105,161,0.3)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#075985]">Call Now</a>
      </li>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { scrollbar-width: none; }
      `}</style>
    </ul>
  );
}
